module.exports = __webpack_public_path__ + "img/folder.18a28eef.svg";